<template>
    <div>
        <div class="pagetitle">
            <h1>Feedback</h1>
            <nav>
                <ol class="breadcrumb">
                    <li class="breadcrumb-item">Home</li>
                    <li class="breadcrumb-item">Forms</li>
                    <li class="breadcrumb-item active">Feedback</li>
                </ol>
            </nav>
        </div>
        <div class="col text-left">
            <a href="#" class="btn btn-sm btn-primary shadow-sm" data-toggle="modal" data-target="#tambahCust">
                <i class="bi bi-plus fa-sm text-white-50"></i> Tambah Feedback
            </a>
        </div> <br>
        <div>
            <div class="row-mb-3">
                <div class="col-lg-12">
                    <div class="card">
                        <div class="card-body">
                            <h5 class="card-title">Feedback</h5>
                            <div class="form-group mb-3">
                                <label for="searchQuery" class="form-label">Search:</label>
                                <input type="text" v-model="searchQuery" @change="fetchCust" class="form-control">
                                <div class="form-group mb-3 d-inline-block mr-3">
                                    <label for="pageSize" class="form-label">Items per page:</label>
                                    <select id="pageSize" v-model="pageSize" @change="fetchCust" class="form-select">
                                        <option v-for="size in [1, 5, 10, 15, 20, 100]" :key="size" :value="size">
                                            {{ size }}
                                        </option>
                                    </select>
                                </div>
                                <div class="form-group mb-3 d-inline-block mr-3">
                                    <label for="periode" class="form-label">Periode:</label>
                                    <select name="periode" id="periode" v-model="periode" @click="fetchCust" class="form-select"> <!--@change="fetchApplicants" -->
                                        <option value="all">Semua</option>
                                        <option value="1 week">1 Minggu</option>
                                        <option value="1 month">1 Bulan</option>
                                        <option value="1 year">1 Tahun</option>
                                    </select>
                                </div>
                                <div class="form-group mb-3 d-inline-block">
                                    <a href="#" class="btn btn-sm btn-success shadow-sm" @click="downloadRateList">
                                        <i class="bi bi-download fa-sm text-white-50"></i> Download Data
                                    </a>
                                </div>
                                <table class="table table-striped table-hover">
                                    <thead class="thead-dark">
                                        <tr>
                                            <th scope="col">No</th>
                                            <th scope="col">Name</th>
                                            <th scope="col">Score</th>
                                            <th scope="col" style="text-align: center;">Opsi</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(cust, index) in filteredCust" :key="cust.id">
                                            <td>{{ index + 1 + (currentPage - 1) * pageSize }}</td>
                                            <td>{{ cust.name_rater }} - {{  cust.name_company }}</td>
                                            <td>Rate : {{ cust.score }}</td>
                                            <td style="text-align: center;">
                                                <a href="#" class="btn btn-sm btn-outline-primary shadow-sm" style="margin-right: 5px" @click="showModal('detail', cust.id)">
                                                    <i class="bi bi-eye fa-sm text-dark"></i>
                                                </a>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                <nav aria-label="Page navigation">
                                    <ul class="pagination justify-content-center" @change="fetchCust">
                                        <li class="page-item" :class="{ disabled: currentPage === 1 }">
                                            <button class="page-link" @click="changePage(currentPage - 1)" :disabled="currentPage === 1">Previous</button>
                                        </li>
                                        <li v-if="showStartEllipsis" class="page-item disabled">
                                            <span class="page-link">...</span>
                                        </li>
                                        <li
                                            class="page-item"
                                            v-for="page in displayedPages"
                                            :key="page"
                                            :class="{ active: currentPage === page }"
                                        >
                                            <button class="page-link" @click="changePage(page)">{{ page }}</button>
                                        </li>
                                        <li v-if="showEndEllipsis" class="page-item disabled">
                                            <span class="page-link">...</span>
                                        </li>
                                        <li class="page-item" :class="{ disabled: currentPage === pages }">
                                            <button class="page-link" @click="changePage(currentPage + 1)" :disabled="currentPage === pages">Next</button>
                                        </li>
                                    </ul>
                                </nav>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Modal Detail  -->
        <div ref="detailCustModal" class="modal fade" id="detailCust" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="detailAreaModalLabel">Detail Feedback</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closeModal">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="form-group">
                            <label for="nameRater">Name Rater</label>
                            <input type="text" class="form-control" id="nameRater" v-model="selectedCust.name_rater" readonly>
                        </div>
                        <div class="form-group">
                            <label for="nameCompany">Name Company</label>
                            <input type="text" class="form-control" id="nameCompany" v-model="selectedCust.name_company" readonly>
                        </div>
                        <div class="form-group">
                            <label for="score">Score</label>
                            <input type="text" class="form-control" id="score" v-model="selectedCust.score" readonly>
                        </div>
                        <div class="form-group">
                            <label for="score">Email</label>
                            <input type="text" class="form-control" id="score" v-model="selectedCust.email" readonly>
                        </div>
                        <div class="form-group">
                            <label for="score">No. Handphone</label>
                            <input type="text" class="form-control" id="score" v-model="selectedCust.no_hp" readonly>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal" aria-label="Close" @click="closeModal">Close</button>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal fade" id="tambahCust" tabindex="-1" aria-labelledby="rateModalLabel" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="tambahSuratModalLabel">Feddback Forms</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <form class="row g-3" @submit.prevent="addCust">
                            <section v-if="currentStep === 1">
                                <div class="progress mb-3">
                                    <div class="progress-bar" role="progressbar" :style="`width: ${50}%`" aria-valuenow="33.33" aria-valuemin="0" aria-valuemax="100"></div>
                                </div>
                                <h5 class="mt-3">Informasi Pribadi</h5>
                                <div class="col-md-12 mb-3">
                                    <h6 class="fs-6">Nama</h6>
                                    <input type="text" class="form-control" v-model="cust.name">
                                </div>
                                <div class="col-md-12 mb-3">
                                    <h6 class="fs-6">Nama Perusahaan</h6>
                                    <input type="text" class="form-control" v-model="cust.name_company">
                                </div>
                                <div class="col-md-12 mb-3">
                                    <h6 class="fs-6">E-mail</h6>
                                    <input type="text" class="form-control" v-model="cust.email">
                                </div>
                                <div class="col-md-12 mb-3">
                                    <h6 class="fs-6">No. Handphone</h6>
                                    <input type="text" class="form-control" v-model="cust.phone">
                                </div>
                                <button type="button" class="btn btn-primary" @click="nextStep">Next</button>
                            </section>
                            
                            <section v-if="currentStep === 2">
                                <div class="progress mb-3">
                                    <div class="progress-bar" role="progressbar" :style="`width: ${100}%`" aria-valuenow="66.67" aria-valuemin="0" aria-valuemax="100"></div>
                                </div>
                                <h4 class="mt-3">Pertanyaan</h4>
                                <div v-for="(x, questionIndex) in rateList" :key="questionIndex" class="col-md-6 mb-3">
                                    <h6 class="fs-6">{{ questionIndex + 1 }}. {{ x.question }}</h6>
                                    <input type="hidden" class="form-control" :data-question="x.id" :value="x.id" readonly>
                                    <div v-for="(y, answerIndex) in x.answers" :key="y.id" class="mb-2">
                                        <div v-if="y.answer_type === 'text'" class="input-group input-group-sm">
                                            <span class="input-group-text">{{ y.answer }}</span>
                                            <input type="text" class="form-control" :data-question="questionIndex" :data-answer="answerIndex" />
                                        </div>
                                        <div v-else-if="y.answer_type === 'radio'" class="form-check form-check-inline">
                                            <input class="form-check-input" type="radio" :name="`radio-${questionIndex}`" :value="y.answer" :score="y.score"  :id="y.answer_id" />
                                            <label class="form-check-label">{{ y.answer }}</label>
                                        </div>
                                    </div>
                                </div>
                                <button type="button" class="btn btn-warning" @click="showRecaptcha">Verifikasi</button>
                                <!-- reCAPTCHA -->
                                <div v-if="isRecaptchaVisible">
                                    <div class="g-recaptcha" data-sitekey="6LfRUf8qAAAAAC63hlnC4ozvaul5QxOCrPoG0oK5" data-callback="onRecaptchaSuccess"></div>
                                </div>
                                <button type="button" class="btn btn-secondary" @click="prevStep">Back</button>
                                <div class="col-12 text-center">
                                    <button type="submit" class="btn btn-primary">Submit</button>
                                </div>
                            </section>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import custjs from './jsRate/rate';
export default custjs;
</script>